<template>
  <b-dropdown :text="bottleSizeDropdownText(currentBottleSize)" class="yearsDropdown">
    <b-dropdown-item :value="null" @click="emitChangedBottleSize(null)">
        n/a
    </b-dropdown-item>
    <b-dropdown-item v-for="size in getBottleSizes" :key="size.id" :value="size.id" @click="emitChangedBottleSize(size)">
      {{ size.attributes.amount }} {{ $t('general.liter_short') }}
    </b-dropdown-item>
  </b-dropdown>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'BottleSizeDropdown',
  props: {
    selectedBottleSize: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      shownBottleSize: null
    }
  }, 
  computed: {
    ...mapGetters(['getBottleSizes']),
    currentBottleSize() {
      // Use shownBottleSize if it exists, otherwise fallback to selectedBottleSize
      const bottleSize = this.shownBottleSize || this.selectedBottleSize;
      if (!bottleSize) return null;
      
      // Find matching bottle size from the available options
      const amount = bottleSize.attributes ? 
        bottleSize.attributes.amount : 
        bottleSize.amount;
        
      return this.getBottleSizes.find(size => size.attributes.amount === amount) || bottleSize;
    }
  },
  created() {
    this.shownBottleSize = this.selectedBottleSize
  },
  watch: {
    selectedBottleSize(newVal) {
      this.shownBottleSize = newVal
    }
  },
  methods: {
    bottleSizeDropdownText(bottleSize) {
      if (!bottleSize) {
        return 'n/a'
      } else {
        // Handle both data structures: direct amount or attributes.amount
        const amount = bottleSize.attributes ? bottleSize.attributes.amount : bottleSize.amount;
        return `${amount} ${this.$t('general.liter_short')}`
      }
    },
    emitChangedBottleSize(bottleSize) {
      this.shownBottleSize = bottleSize
      this.$emit('bottle-size-changed', bottleSize);
    }
  }
}
</script>

<style scoped>
</style>
